$(function () {

    // cookie notice
    //if (Cookies.get('siteCookie')) {
    //    // console.log("there is a cookie");
    //    $('.cookie-notice').hide();
    //} else {
    //    $('.cookie-notice').css('display', 'block');
    //    $('.cookie-notice__close').click(function () {
    //        Cookies.set('siteCookie', 'accepted', {
    //            expires: 365
    //        });
    //        $(this).parent().parent().hide();
    //    });
    //}


    // Remove loading window
    setTimeout(function () {
        $('main.loading-overlay').addClass('loading-overlay--hide');
        // $('body').addClass('body--loaded');
    }, 500);



});


function scrollToAnchorClass(aClass) {
    //console.log('aClass : %o', aClass);
    var aTag = $(aClass);
    if (typeof aTag === 'undefined' || aTag === null || aTag.length < 0 ) {
        console.log('Can\'t find element with the class : %o', aClass);
    } else {
        $('html,body').animate({ scrollTop: aTag.offset().top }, 800);
    }
}
function scrollToAnchor(aid) {
    var aTag = $(aid);
    if (typeof aTag === 'undefined' || aTag === null || aTag.length < 0) {
        console.log('Can\'t find element with the id :%o', aid);
    } else {
        $('html,body').animate({ scrollTop: aTag.offset().top }, 800);
    }
}
function scrollToAnchorOffset(aid, offset) {
    var aTag = $(aid);
    $('html,body').animate({ scrollTop: aTag.offset().top + offset }, 800);
}







// Handlebars Helpers

Handlebars.registerHelper('raw', function (text) {
    return new Handlebars.SafeString(text);
});
Handlebars.registerHelper('dateFormat', function (dateText) {

    //console.log('dateText : %o', dateText);
    dateText = Handlebars.Utils.escapeExpression(dateText);
    date = moment(dateText, "YYYY-MM-DDTHH:mm");

    var result = moment(date).format('DD/MM/YYYY');

    return new Handlebars.SafeString(result);
});
Handlebars.registerHelper('dateFormatTime', function (dateText) {

    //console.log('dateText : %o', dateText);
    dateText = Handlebars.Utils.escapeExpression(dateText);
    date = moment(dateText, "YYYY-MM-DDTHH:mm");

    var result = moment(date).format('DD/MM/YYYY HH:mm');

    return new Handlebars.SafeString(result);
});
Handlebars.registerHelper('truncate', function (str, len) {
    str = strip(str);

    if (str.length > len && str.length > 0) {
        var new_str = str + " ";
        new_str = str.substr(0, len);
        new_str = new_str.length > 0 ? new_str : str.substr(0, len);

        return new Handlebars.SafeString(new_str + ' ...');
    }
    return str;
});
Handlebars.registerHelper('formattedSlug', function (title) {
    return new Handlebars.SafeString(
        urlEscapeString(title.toLowerCase())
    );
});
Handlebars.registerHelper('sortTitle', function (title) {
    return new Handlebars.SafeString(
        title.replace("||", "<br/>")
    );

});

// Handlebars Helpers


function strip(html) {
    html = stripBreakTags(html);
    return html.replace(/<[^>]*>?/gm, '');
}

function stripBreakTags(html) {
    var br1 = /<br \/>/gi;
    var br2 = /<br>/gi;
    var br3 = /<br\/>/gi;
    return html.replace(br1, ' ').replace(br2, ' ').replace(br3, ' ');
}

function escapeSingleQuote(str) {
    return str; //.replace("'", "\'");
}

function setHeaderAuth() {
    headers = {
        'Content-Type': 'application/json',
        'Abp.Localization.CultureName': language
    };
    return headers;
}
function facTrim(x) {
    return x.replace(/^\s+|\s+$/gm, '');
}

if (!String.format) {
    String.format = function (format) {
        var args = Array.prototype.slice.call(arguments, 1);
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] !== 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}